import React from 'react';
import { remCalc } from 'utils';
var COUNT_LABEL_STYLES = 'm-auto font-body font-hairline text-center text-body opacity-75';
export var CountLabel = function (_a) {
    var fontSize = _a.fontSize, children = _a.children;
    var COUNT_LABEL_INLINE_STYLES = { fontSize: fontSize !== null && fontSize !== void 0 ? fontSize : remCalc(7) };
    return (React.createElement("p", { style: COUNT_LABEL_INLINE_STYLES, className: COUNT_LABEL_STYLES }, children));
};
CountLabel.displayName = 'Content.CountLabel';
